<button
  *ngIf="!buttonDetails.errorDetails; else errorButton"
  [disabled]="buttonDetails.isDisabled | avanoButtonBarIsActive"
  (click)="onActionTriggered(buttonDetails)"
  class="avano-button-bar-button"
  [class.avano-button-bar-button-call-to-action]="buttonDetails.isCallToActionButton"
>
  <div class="avano-button-bar-button-content-wrapper">
    <i [class]="'avano-button-bar-button-icon ' + buttonDetails.icon"></i>
    <div
      class="avano-button-bar-button-label"
      [innerHTML]="(buttonDetails.noTranslate ? buttonDetails.label : (buttonDetails.label | translate)) | avanoButtonBarLabel"
    ></div>
  </div>
</button>

<ng-template #errorButton>
  <button
    *ngIf="buttonDetails.errorDetails?.length > 0"
    class="avano-button-bar-button avano-button-error"
    [avanoErrorsPopover]="buttonDetails.errorDetails"
  >
    <div class="avano-button-bar-button-content-wrapper">
      <span>
        <i [class]="'avano-button-bar-button-icon ' + (buttonDetails.icon ?? 'icon-content-error')"></i>
        <i class="avano-button-bar-button-icon icon-content-expand"></i>
      </span>
      <div
        class="avano-button-bar-button-label"
        [innerHTML]="
          (buttonDetails.noTranslate ? buttonDetails.label : (buttonDetails.label | translate)) ??
            ('avano.buttonBar.common.btn.error' | translate : {count: buttonDetails.errorDetails.length}) | avanoButtonBarLabel
        "
      ></div>
    </div>
  </button>
</ng-template>
